<div class="header-container">
  <div class="header-col-1">
    <img src="assets/images/gbar-logo_66897.png" />
  </div>
  <div  class="sb-banner-header header-col-2">{{headerText}}</div>
  <div class="header-col-3">

</div>
